import { supabase } from "../../supabase";

// supabase-js already stores, refreshes and clears the token - this only ever reads it
export const tokenRepository = {
  getAccessToken: async (): Promise<string> => {
    const {
      data: { session },
      error
    } = await supabase.auth.getSession();

    if (error) {
      throw new Error(`Authentication error: ${error.message}`);
    }

    if (!session?.access_token) {
      throw new Error("No access token available - user may need to re-authenticate");
    }

    return session.access_token;
  }
};
